import { Section, H2, H3, DataField } from "./common-components";
import { formatDateToDD_MMM_YYYY } from "../../../helpers/functions";
import {
  designationOptions,
  notificationMethodOptions,
  notificationTypeOptions,
  referralTypeCard,
} from "../../patient/clinical-services/service-steps/education/data";
import { GetDropDownValue, GetMultiDropDownValue } from "./data";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const ReferralsAndNotifications = ({ referral, onlyContactInfo = false, documentation, formType }) => {
  // const { documentation, formType } = useContext(FormContextMA);
  const { referralInformations, notificationInformations } =
    documentation || {};

  // Check if this is an intervention form
  const isInterventionForm = (() => {
    if (!formType) return false;
    const lowerFormType = formType.toLowerCase();
    return lowerFormType.includes("intervention") || lowerFormType.includes("prescribing");
  })();

  return (
    <>
      {isInterventionForm ? (
        <Section formType={formType}>
          <div className="space-y-1">
            <div className="grid grid-cols-2">
              <H2 className="text-sm -mt-1">Notification of Service</H2>
              <DataField
                label="Date of Notification"
                value={
                  documentation?.dateOfNotification
                    ? formatDateToDD_MMM_YYYY(
                        documentation?.dateOfNotification
                      )
                    : ""
                }
                className="pl-5"
              />
              <DataField
                label="Notification Type"
                value={GetMultiDropDownValue(
                  notificationTypeOptions,
                  documentation?.notificationType?.join(", ")
                )}
              />
              <DataField
                label="Method of Notification"
                value={
                  notificationMethodOptions.find(
                    (o) => o.value === documentation?.methodOfNotification
                  )?.label || ""
                }
                className="pl-5"
              />
            </div>
          </div>
        </Section>
      ) : [
        AllergicRhinitisDocTypes.PhysicianReferralForm,
        AllergicRhinitisDocTypes.PrescribingRecord,
        AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
      ].includes(formType) ? (
        <>
          <Section formType={formType}>
            {onlyContactInfo ? (
              <div className="space-y-1">
                <H2 className="text-sm">
                  Notification Type Contact Information
                </H2>
                <div className="grid grid-cols-2">
                  {!documentation?.notificationType?.includes(
                    "nonApplicable"
                  ) ? (
                    <>
                      <DataField
                        label="Date"
                        value={
                          documentation?.dateOfNotification
                            ? formatDateToDD_MMM_YYYY(
                                documentation?.dateOfNotification
                              )
                            : ""
                        }
                      />
                      <DataField
                        label="Type"
                        value={GetMultiDropDownValue(
                          notificationTypeOptions,
                          documentation?.notificationType?.join(", ")
                        )}
                      />
                      <DataField
                        label="Method"
                        value={
                          notificationMethodOptions.find(
                            (o) =>
                              o.value === documentation?.methodOfNotification
                          )?.label || ""
                        }
                      />
                    </>
                  ) : (
                    <>
                      <DataField
                        value={GetMultiDropDownValue(
                          notificationTypeOptions,
                          documentation?.notificationType?.join(", ")
                        )}
                      />
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div className="space-y-1">
                <div className="grid grid-cols-2">
                  <H2 className="text-sm">Notification of Service</H2>
                  {!documentation?.notificationType?.includes(
                    "nonApplicable"
                  ) ? (
                    <>
                      <DataField
                        label="Date"
                        value={
                          documentation?.dateOfNotification
                            ? formatDateToDD_MMM_YYYY(
                                documentation?.dateOfNotification
                              )
                            : ""
                        }
                      />
                      <DataField
                        label="Type"
                        value={GetMultiDropDownValue(
                          notificationTypeOptions,
                          documentation?.notificationType?.join(", ")
                        )}
                      />
                      <DataField
                        label="Method"
                        value={
                          notificationMethodOptions.find(
                            (o) =>
                              o.value === documentation?.methodOfNotification
                          )?.label || ""
                        }
                      />
                    </>
                  ) : (
                    <>
                      <DataField
                        value={GetMultiDropDownValue(
                          notificationTypeOptions,
                          documentation?.notificationType?.join(", ")
                        )}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
          </Section>
        </>
      ) : (
        <Section formType={formType}>
          <H2>Notifications &amp; Referral</H2>
          <div className="space-y-4">
            <div className="space-y-1">
              <H3 className="text-sm text-teal-300 font-semibold pb-1">
                Referrals
              </H3>
              <table className="text-xs border border-gray-400 border-collapse w-full rounded-md table-auto">
                <thead>
                  <tr className="text-left bg-gray-20">
                    <th className="border font-normal border-gray-400 p-1">
                      Referral Type
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Referral Name
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Designation
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(referralInformations ?? []).map((d, idx) => (
                    <tr className="font-semibold" key={`ref-${d?.id ?? idx}`}>
                      <td className="border border-gray-400 p-1">
                        {GetDropDownValue(
                          referralTypeCard.options,
                          d?.referralType ?? documentation?.referralType?.[0]
                        ) ?? d?.referralType ?? documentation?.referralType?.[0] ?? ""}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {[d?.lastName, d?.firstName].filter(Boolean).join(" ")}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {GetDropDownValue(designationOptions, d?.designation) ?? ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="space-y-1">
              <H3 className="text-sm text-teal-300 font-semibold pb-1">
                Notifications
              </H3>
              <table className="text-xs border border-gray-400 border-collapse w-full rounded-md table-auto">
                <thead>
                  <tr className="text-left bg-gray-20">
                    <th className="border font-normal border-gray-400 p-1">
                      Notification Type
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Notification Name
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Designation
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Date of Notification
                    </th>
                    <th className="border font-normal border-gray-400 p-1">
                      Method
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(notificationInformations ?? []).map((d, idx) => (
                    <tr className="font-semibold" key={`notif-${d?.id ?? idx}`}>
                      <td className="border border-gray-400 p-1">
                        {GetDropDownValue(
                          notificationTypeOptions,
                          d?.referralType ?? documentation?.notificationType?.[0]
                        ) ?? d?.referralType ?? documentation?.notificationType?.[0] ?? ""}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {[d?.lastName, d?.firstName].filter(Boolean).join(" ")}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {GetDropDownValue(designationOptions, d?.designation) ?? ""}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {documentation?.notificationType?.includes("nonApplicable")
                          ? ""
                          : (documentation?.dateOfNotification
                              ? formatDateToDD_MMM_YYYY(documentation.dateOfNotification)
                              : "")}
                      </td>
                      <td className="border border-gray-400 p-1">
                        {documentation?.notificationType?.includes("nonApplicable")
                          ? ""
                          : (notificationMethodOptions.find(
                              (o) => o.value === documentation?.methodOfNotification
                            )?.label ?? "")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Section>
      )}
    </>
  );
};
